// import { BEditorJsButton, ButtonData } from './components/b-editorjs-button'
import { OutputData } from '@editorjs/editorjs'
import * as Sentry from '@sentry/nextjs'
import clsx from 'clsx'

import BEditorJsButton, { ButtonData } from './components/b-editorjs-button'
import { BEditorJsDelimiter, DelimiterData } from './components/b-editorjs-delimiter'
// import { BEditorJsEmployees, EmployeeData } from './components/b-editorjs-employees'
import { BEditorJsEmbed, EmbedData } from './components/b-editorjs-embed'
import { BEditorJsHeader, HeaderData } from './components/b-editorjs-header'
import { BEditorJsImage, ImageData } from './components/b-editorjs-image'
import BEditorJsImageGallery, { BEditorJsGalleryData } from './components/b-editorjs-image-gallery'
import BEditorJsLinkedAmbulance, {
	LinkedAmbulanceData
} from './components/b-editorjs-linked-ambulance'
import { BEditorJsList, ListData } from './components/b-editorjs-list'
import { BEditorJsNestedList, NestedListData } from './components/b-editorjs-nested-list'
import BEditorJsNewsletter, { NewsletterData } from './components/b-editorjs-newsletter'
import { BEditorJsParagraph, ParagraphData } from './components/b-editorjs-paragraph'
import { BEditorJsQuote, QuoteData } from './components/b-editorjs-quote'
import { BEditorJsTable, TableData } from './components/b-editorjs-table'

export const ZEditorJsRenderer = ({
	data,
	className
}: {
	data: OutputData
	className?: string
}) => {
	if (!data?.blocks || !Array.isArray(data.blocks) || data.blocks.length === 0) return null

	const renderBlock = (block: any, index: number) => {
		try {
			switch (block.type) {
				case 'header':
					return (
						<div key={index}>
							<BEditorJsHeader
								data={block.data as HeaderData}
								style={index === 0 ? { marginTop: 0 } : undefined}
							/>
						</div>
					)
				case 'paragraph':
					return (
						<div key={index}>
							<BEditorJsParagraph data={block.data as ParagraphData} />
						</div>
					)
				case 'list':
					return (
						<div key={index}>
							<BEditorJsList data={block.data as ListData} />
						</div>
					)
				case 'nestedList':
					return (
						<div key={index}>
							<BEditorJsNestedList data={block.data as NestedListData} />
						</div>
					)
				case 'quote':
					return (
						<div key={index}>
							<BEditorJsQuote data={block.data as QuoteData} />
						</div>
					)
				case 'image':
					return (
						<div key={index}>
							<BEditorJsImage data={block.data as ImageData} />
						</div>
					)
				// case 'employee':
				// 	return (
				// 		<BEditorJsEmployees key={block.id} data={block.data as EmployeeData} />
				// 	)
				// case 'button':
				// 	return <BEditorJsButton key={block.id} data={block.data as ButtonData} />
				case 'delimiter':
					return (
						<div key={index}>
							<BEditorJsDelimiter data={block.data as DelimiterData} />
						</div>
					)
				case 'table':
					return (
						<div key={index}>
							<BEditorJsTable data={block.data as TableData} />
						</div>
					)
				case 'gallery':
					return (
						<div key={index}>
							<BEditorJsImageGallery data={block.data as BEditorJsGalleryData} />
						</div>
					)
				case 'embed':
					return (
						<div key={index}>
							<BEditorJsEmbed data={block.data as EmbedData} />
						</div>
					)
				case 'button':
					return (
						<div key={index}>
							<BEditorJsButton data={block.data as ButtonData} />
						</div>
					)
				case 'linkedAmbulance':
					return (
						<div key={index}>
							<BEditorJsLinkedAmbulance data={block.data as LinkedAmbulanceData} />
						</div>
					)
				case 'newsletter':
					return (
						<div key={index}>
							<BEditorJsNewsletter data={block.data as NewsletterData} />
						</div>
					)
				default:
					return (
						<p key={block.id} className='text-red-500 text-center my-16'>
							Unsupported block type: {block.type}
						</p>
					)
			}
		} catch (error) {
			Sentry.captureException(error)

			return null
		}
	}

	try {
		return (
			<div
				className={clsx('editorjs-renderer pb-24', className)}
				suppressHydrationWarning={true}
			>
				{data.blocks.map((block, index) => {
					return renderBlock(block, index)
				})}
			</div>
		)
	} catch (error) {
		Sentry.captureException(error)
		return null
	}
}
